export default {
  appVersion: '1.0.1.20190919.1500',
  image: {
    upload: {
      url: `${window.baseURL}api/file/create`,
    },
  },
  products: {
    details: {
      // url: `${window.baseURL}st/?action=ProductsByID&ids={productIDs}&limit=700`,
      // url: `${window.baseURL}st/memberproductbyid/{user}/{base_group}/{productID}/{key}`,
      url: `${window.baseURL}graphql-product`,
      query: `query readProducts($IDs: [Int!]) {
              readProducts(Filters: {IDs: $IDs}) {
                pageInfo {
                  totalCount
                  hasNextPage
                  hasPreviousPage
                }
                edges {
                  node {
                    ProductType 
                    ContainerType
                    ID
                    Title
                    URLSegment
                    InternalItemID
                    Brand
                    Varietal
                    LiquorStyle
                    BrandRegion
                    BrandCountry
                    DisplayRRP
                    DisplayPrice
                    ReSizedDefaultImage
                    ReSizedProductListingImage
                    UnitRRP
                    UnitPrice
                    CaseRRP
                    CasePrice
                    SoldAt
                    StockForMelbourne
                    StockForSydney
                    StockForAdelaide
                    StockForBrisbane
                    StockForCairns
                    WholesaleUnitsPerCase
                    ItemsInCase
                    SellByPackageOnly
                    WebCategory
                    Created
                    EnCreated
                    HasCocktails
                    LoyaltyPoints
                    SupplierLoyaltyPoints
                    BonusLoyaltyPoints
                    PointsExcludedFromRetail
                    WetTax
                    SplitPackSize
                    LongtermOOS {
                      edges {
                        node {
                          ID
                          Location {
                            ID
                          }
                          Date
                        }
                      }
                    }
                    
                  }
                }
              }
            }`,
    },
    listing: {
      //url: `${window.baseURL}st/?action=@@@FilterProducts&sortBy=SortableTitle:asc`,
      url: `${window.baseURL}graphql-product`,
      query: `{
                searchResult({params}) {
                    pageInfo {
                        totalCount
                        hasNextPage
                        hasPreviousPage
                    }
                    edges {
                        node {
                            ID
                            Title
                            URLSegment
                            InternalItemID
                            Brand
                            Varietal
                            LiquorStyle
                            BrandRegion
                            BrandCountry
                            DisplayRRP
                            DisplayPrice
                            ProductType 
                            ContainerType
                            ReSizedDefaultImage
                            ReSizedProductListingImage
                            UnitRRP
                            UnitPrice
                            CaseRRP
                            CasePrice
                            SoldAt
                            StockForMelbourne
                            StockForSydney
                            StockForAdelaide
                            ItemsInCase
                            WebCategory
                            Created
                            LoyaltyPoints
                            SupplierLoyaltyPoints
                            BonusLoyaltyPoints
                            SplitPackSize
                            LongtermOOS {
                              edges {
                                node {
                                  ID
                                  Location {
                                    ID
                                  }
                                  Date
                                }
                              }
                            }
                        }
                    }
                }
            }`,
    },
    newArrival: {
      url: `${window.baseURL}st/?action=NewArrivalProducts&limit={amount}&offset={startingIndex}`,
      // url: `${window.baseURL}st/products/{groupID}/{category}/{startingIndex}/{amount}`,
    },
    filters: {
      url: `${window.baseURL}st/?action=FilterProducts&catid={category}&limit={amount}&offset={startingIndex}`,
      // url: `${window.baseURL}st/filterproducts/{groupID}/{category}/{brands}/{regions}/{countries}`,
    },
    search: {
      url: `${window.baseURL}st/?action=searchProducts&q={keyword}&limit={amount}&offset={startingIndex}`,
    },
    replacements: {
      url: `${window.baseURL}st/?action=SubstituteProducts&ptype={type}&style={style}&varietal={varietal}&pid={productid}&limit={limit}`,
    },
  },
  filters: {
    list: {
      url: `${window.baseURL}graphql-product`,
      query: `query productFilters(
        $q: String
        $CategoryURL: String
        $ContainerType: [String]
        $Varietal: [String]
        $LiquorStyle: [String]
        $Brand: [String]
        $Country: [String]
        $Region: [String]
      ) {
        productFilters(
          q: $q
          CategoryURL: $CategoryURL
          ContainerType: $ContainerType
          Varietal: $Varietal
          LiquorStyle: $LiquorStyle
          Brand: $Brand
          Country: $Country
          Region: $Region
        ) {
          Title
          Items
          DisplayTitle
          IsCollapsed
          FilterSort
        }
      }`,
    },
    brands: {
      url: `${window.baseURL}st/?action=GetFilters&filter=Brand&catid={category}&limit=9999`,
    },
    countries: {
      url: `${window.baseURL}st/?action=GetFilters&filter=Country&catid={category}&limit=9999`,
    },
    regions: {
      url: `${window.baseURL}st/?action=GetFilters&filter=Region&catid={category}&limit=9999`,
    },
    styles: {
      url: `${window.baseURL}st/?action=GetFilters&filter=Style&catid={category}&limit=9999`,
    },
    types: {
      url: `${window.baseURL}st/?action=GetFilters&filter=PType&catid={category}&limit=9999`,
    },
    varietal: {
      url: `${window.baseURL}st/?action=GetFilters&filter=Varietal&catid={category}&limit=9999`,
    },
  },
  authentication: {
    login: {
      url: `${window.baseURL}graphql`,
      query: `mutation Login($email:String!, $password:String!){
              loginMemberMutation (Email:$email, Password:$password) {
                Token
                OTPCreated
                Member {
                  ID
                  Email
                  FirstName
                  Surname
                  ClassName
                }
              }
            }`,
    },
    loginWithOTP: {
      url: `${window.baseURL}graphql`,
      query: `mutation Login($email:String!, $password:String!, $otp: Int){
              loginMemberMutation (Email:$email, Password:$password, OTP: $otp) {
                Token
                Member {
                  ID
                  Email
                  FirstName
                  Surname
                  ClassName
                }
              }
            }`,
    },
    forgetPassword: {
      url: `${window.baseURL}graphql`,
      query: `mutation ResetPassword($email:String!){
              resetMemberPassword (Email:$email) {
                ID
                Email
              }
            }`,
    },
    createSignup: {
      url: `${window.baseURL}graphql`,
      query: `mutation createEvolutionEventEnquiry($FullName: String!, $Email: String!, $Mobile: String!, $VenueName: String, $Position: String) {
              createEvolutionEventEnquiry(FullName: $FullName, Email: $Email, Mobile: $Mobile, VenueName: $VenueName, Position: $Position)  {
                FullName
                Email
                Mobile
              }             
            }`,
    },
    createAirwallexCustomerSignup: {
      url: `${window.baseURL}graphql`,
      query: `mutation  {
           createAirwallexCustomer  {
              CustomerID
              CustomerSecret
              }             
            }`,
    },
    createAirwallexCreditCard: {
      url: `${window.baseURL}graphql`,
      query: `mutation createCreditCard(
        $Number: String!
        $ExpiryMonth: Int
        $ExpiryYear: Int
        $Gateway: String
        $Token: String
        $CardName: String
        $CardReference: String
        $CardIssuer: String
      ) {
        createCreditCard(
          Input: {
            Number: $Number
            ExpiryMonth: $ExpiryMonth
            ExpiryYear: $ExpiryYear
            Gateway: $Gateway
            Token: $Token
            CardName: $CardName
            CardReference: $CardReference
            CardIssuer: $CardIssuer
          }
        ) {
          ID
          CardName
          Title
        }
      }`,
    },
  },
  triggerDiscount: {
    url: `${window.baseURL}graphql-enterprise`,
    query: `mutation {
      triggerDiscountSync {
        ID
      }
    }`,
  },
  contact: {
    url: `${window.baseURL}graphql`,
    query: `mutation createContactEnquiry($FirstName: String!,$LastName: String!, $Email: String!, $Phone: String!, $Message: String!, $SentFrom: String) {
          createContactEnquiry (FirstName: $FirstName,LastName:$LastName, Email: $Email, Phone: $Phone, Message: $Message, SentFrom: $SentFrom) {
            ID
          }
        }`,
  },

  registration: {
    wholesaler: {
      url: `${window.baseURL}graphql`,
      query: `mutation createOrUpdateWholesalerRegistration(
              $IsFinalStep: Boolean,
              $ID: Int,
              $LegalEntityName: String,
              $TradingName: String,
              $EntityType: String,
              $ABN: String,
              $ACN: String,
              $LiquorLicenseNumber: String,
              $OutletType: String,
              $BusinessAddress: String,
              $BusinessCity: String,
              $BusinessState: String,
              $BusinessPostalCode: String,
              $FirstName: String,
              $Surname: String,
              $DOB: String,
              $Position: String,
              $ContactNumber: String,
              $Email: String,
              $PreferredDeliveryDay: String,
              $PreferredDeliveryWindow: String,
              $DeliveryInstructions: String,
              $ApplyCommercialCreditTerms: Boolean,
              $CommercialCreditDirectors: [WholesalerRegistrationEnquiryCommercialCreditDirectorsInputType],
              $InternalAccountsPayableFirstName: String,
              $InternalAccountsPayableSurname: String,
              $InternalAccountsPayableContactNumber: String,
              $InternalAccountsPayableEmail: String,
              $ReferralSourced: String,
              $OtherReferralSourced: String,
              $UnitNumber: String,
              $StreetNumber: String,
              $OutletStyle: String,
              $Cuisine: String,
              $StreetName: String

            ) {
              createOrUpdateWholesalerRegistration(
                IsFinalStep: $IsFinalStep,
                ID: $ID,
                LegalEntityName: $LegalEntityName,
                TradingName: $TradingName,
                EntityType: $EntityType,
                ABN: $ABN,
                ACN: $ACN,
                LiquorLicenseNumber: $LiquorLicenseNumber,
                OutletType: $OutletType,
                BusinessAddress: $BusinessAddress,
                BusinessCity: $BusinessCity,
                BusinessState: $BusinessState,
                BusinessPostalCode: $BusinessPostalCode,
                FirstName: $FirstName,
                Surname: $Surname,
                DOB: $DOB,
                Position: $Position,
                ContactNumber: $ContactNumber,
                Email: $Email,
                PreferredDeliveryDay: $PreferredDeliveryDay,
                PreferredDeliveryWindow: $PreferredDeliveryWindow,
                DeliveryInstructions: $DeliveryInstructions,
                ApplyCommercialCreditTerms: $ApplyCommercialCreditTerms,
                CommercialCreditDirectors: $CommercialCreditDirectors,
                InternalAccountsPayableFirstName: $InternalAccountsPayableFirstName,
                InternalAccountsPayableSurname: $InternalAccountsPayableSurname,
                InternalAccountsPayableContactNumber: $InternalAccountsPayableContactNumber,
                InternalAccountsPayableEmail: $InternalAccountsPayableEmail,
                OtherReferralSourced:$OtherReferralSourced,
                ReferralSourced:$ReferralSourced,
                UnitNumber: $UnitNumber,
                StreetNumber: $StreetNumber,
                OutletStyle: $OutletStyle,
                Cuisine: $Cuisine,
                StreetName: $StreetName

              ) {
                ID
              }
            }`,
    },
    supplier: {
      url: `${window.baseURL}graphql`,
      query: `mutation createSupplierEnquiryRegistration($Input: CreateSupplierInputType) {
                createSupplierEnquiryRegistration(Input: $Input) {
                  ID
                  SupplierName
                  Company
                }
              }`,
    },
    subUrbs: {
      threePlReadSuburbs: {
        url: `${window.baseURL}graphql`,
        query: `query($LocationID: Int!, $PostCode: String!) {
          readSuburbs(LocationID: $LocationID, PostCode: $PostCode) {
            ID
            PostCode
            City
          }
        }
        `,
      },
    },
  },
  careers: {
    applyForJob: {
      url: `${window.baseURL}graphql`,
      query: `mutation createJobApplication($Input: JobApplicationInputType){
        createJobApplication(Input: $Input){
          ID
        }
      }`,
    },
  },
}
